<div *ngIf="isAdmin" class="backup-container">
  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <div class="backup-actions">
    <select *ngIf="backups.length > 0" class="backup-select" [(ngModel)]="selectedBackup" [disabled]="backups.length === 0">
      <option value="" disabled selected>{{ 'Select a backup' | translate }}</option>
      <option *ngFor="let backup of backups; index as i" [value]="i">{{ backup }}</option>
    </select>

    <button class="stacksBtn primary" (click)="onRestore()" [disabled]="backups.length === 0">{{ 'Restore items' | translate }}</button>

    <button class="stacksBtn secondary" (click)="getBackups()" [disabled]="backups.length > 0">{{ 'Get all backups' | translate }}</button>
  </div>
</div>
